let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eidsh")).then(() => parcelRequire('1eGK0'));